import React from "react";
import BG from "../../assets/about/BGabout.png";
import Box from "../../assets/about/MetaCube.gif";
import BlockChain from "../../components/about/blockchain";

function About() {
  return (
    <div
      className="pt-28 lg:pt-36 h-screen w-full flex flex-col justify-start bg-gradient-to-b from-[#2B2E82] to-[#0A0918] bg-cover bg-center bg-no-repeat md:flex"
      style={{
        backgroundImage: `url(${BG})`,
      }}
    >
      <div className="flex flex-col">
        <div className="flex flex-col lg:flex-row w-[80%] m-auto ">
          <div>
            <img
              src={Box}
              alt=""
              className=" mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0] m-auto w-auto max-w-[40%] md:w-[30%] lg:w-full lg:max-w-full lg:ml-[50%] lg:scale-105  sm:scale-105"
            />
          </div>
          <div className="flex items-center justify-center">
            <div className="text-white md:text-left break-words lg:w-[70%] lg:text-[24px] sm:mt-[3rem] sm:text-left sm:pl-[2rem] sm:pr[1rem] sm:text-[18px] font-bold">
              Nverse is a highly skilled blockchain solutions provider committed
              to providing the most advanced and efficient technologies for
              enterprise clients.
            </div>
          </div>
        </div>
        <BlockChain />
      </div>
    </div>
  );
}

export default About;
